// Built-in template presets. These are non-deletable.
// Custom user templates come from the backend via /api/templates.

export const builtInTemplates = {
  'session-starting': {
    id: 'session-starting',
    name: 'Session Starting Shortly',
    title: 'Session Starting Shortly',
    paragraph: 'The next session will begin shortly.\nPlease ensure microphones remain muted during presentations.\nQuestions may be submitted through the Zoom chat panel.',
    lower_text: 'International Reporting Inc. \u2022 Professional Court Reporting Services',
    builtin: true,
  },
  'break-progress': {
    id: 'break-progress',
    name: 'Break in Progress',
    title: 'Break in Progress',
    paragraph: 'We are currently on a scheduled break.\nThe session will resume at the designated time.\nPlease remain available and ready to rejoin.',
    lower_text: 'Break Time \u2022 Please Stand By',
    builtin: true,
  },
  'technical-intermission': {
    id: 'technical-intermission',
    name: 'Technical Intermission',
    title: 'Technical Intermission',
    paragraph: 'We are experiencing a brief technical intermission.\nOur team is working to resolve the issue.\nThank you for your patience and understanding.',
    lower_text: 'Technical Support \u2022 We Will Resume Shortly',
    builtin: true,
  },
  'next-panel': {
    id: 'next-panel',
    name: 'Next Panel Beginning Soon',
    title: 'Next Panel Beginning Soon',
    paragraph: 'The upcoming panel discussion will begin momentarily.\nPlease review any materials shared in advance.\nEnsure your audio and video settings are configured.',
    lower_text: 'Preparing Next Session \u2022 International Reporting Inc.',
    builtin: true,
  },
  'stand-by': {
    id: 'stand-by',
    name: 'Please Stand By',
    title: 'Please Stand By',
    paragraph: 'Thank you for joining us today.\nWe will be with you shortly.\nPlease remain connected.',
    lower_text: 'International Reporting Inc.',
    builtin: true,
  },
  'recording-progress': {
    id: 'recording-progress',
    name: 'Recording in Progress',
    title: 'Recording in Progress',
    paragraph: 'This proceeding is being recorded for transcription purposes.\nUnauthorized distribution or reproduction is prohibited.\nAll participants consent to recording by joining this session.',
    lower_text: '\ud83d\udd34 REC \u2022 Confidential Session \u2022 International Reporting Inc.',
    builtin: true,
  },
  'custom': {
    id: 'custom',
    name: 'Custom (Blank)',
    title: 'Enter Your Custom Title',
    paragraph: 'Enter your custom paragraph text here.\nYou can use multiple lines to convey your message.\nEdit this text to match your specific needs.',
    lower_text: 'International Reporting Inc.',
    builtin: true,
  },
};

// Legacy export for backwards-compatibility (existing code reads `templates[id]`)
export const templates = builtInTemplates;
